module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group xigua-input-number custom-input-group-width",
    class: [
      _vm.size ? 'input-' + _vm.size : '',
      {
        'disabled': _vm.disabled
      }
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "form-control",
    class: _vm.size ? 'input-' + _vm.size : '',
    attrs: {
      "type": "number",
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        $event.preventDefault();
        _vm.increase($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        $event.preventDefault();
        _vm.decrease($event)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon custom-input-group-addon"
  }, [_c('div', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    class: {
      'disabled': _vm.maxDisabled
    }
  }, [_c('i', {
    staticClass: "icon-angle-up"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    class: {
      'disabled': _vm.minDisabled
    }
  }, [_c('i', {
    staticClass: "icon-angle-down"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055a5f12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-number-custom/index.vue
// module id = 495
// module chunks = 0